import { library } from '@fortawesome/fontawesome-svg-core'
import { faTimes, faSearch, faLocationArrow, faChevronLeft, faChevronRight, faMinus, faPlus, faEnvelope, faPhone, faExternalLinkAlt, faStar, faFileInvoiceDollar, faThumbsDown, faThumbsUp, faShoppingCart, faTruck, faCheck, faSlidersH, faKey, faSignOutAlt, faReceipt, faStopwatch, faAngleUp, faFilter, faCheckSquare, faExchangeAlt, faShoppingBag, faTag, faPercentage, faClock } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faAngleUp,
  faCheck,
  faCheckSquare,
  faChevronLeft,
  faChevronRight,
  faEnvelope,
  faExternalLinkAlt,
  faFileInvoiceDollar,
  faFilter,
  faKey,
  faLocationArrow,
  faMinus,
  faPhone,
  faPlus,
  faReceipt,
  faSearch,
  faShoppingCart,
  faSignOutAlt,
  faSlidersH,
  faStar,
  faStopwatch,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faTruck,
  faExchangeAlt,
  faShoppingBag,
  faTag,
  faPercentage,
  faClock
);

export { FontAwesomeIcon };
